import { mainActionTypes } from '../../settings/types'

export const clearState = () => ({
    type : mainActionTypes.clearState,
});

export const setViewMode = ( viewMode= 'LIST') => ({
    type : mainActionTypes.view,
    payload : viewMode
});

export const setLoading = data => ({
    type : mainActionTypes.loading,
    payload : data
});

export const setUdn = data => ({
    type : mainActionTypes.udn,
    payload: data
});

export const setModule = data => ({
    type : mainActionTypes.module,
    payload: data
});

export const setMenu = data => ({
    type : mainActionTypes.menu,
    payload: data
});

export const setApp = data => ({
    type : mainActionTypes.app,
    payload: data
});

export const setCategory = data => ({
    type : mainActionTypes.category,
    payload: data
});

export const setParent = data => ({
    type : mainActionTypes.parent,
    payload: data
});

export const setMapConfig = data => ({
    type : mainActionTypes.mapConfig,
    payload: data
});

export const setUserIsAdmin = data => ({
    type : mainActionTypes.userIsAdmin,
    payload: data
});